// Copyright © 2026 ApexRuntime Labs by Shashi (https://github.com/spshah). All rights reserved.

import { useRouteError, Link } from 'react-router-dom';

export default function ErrorPage() {
  const error = useRouteError();

  const status = error?.status ?? error?.response?.status;
  const message =
    error?.statusText || error?.message || 'An unexpected error occurred.';

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="text-center max-w-md">
        <p className="text-6xl font-bold text-indigo-600 mb-4">
          {status ?? '!'}
        </p>

        <h1 className="text-2xl font-semibold text-gray-900 mb-2">
          Something went wrong
        </h1>

        <p className="text-sm text-gray-500 mb-8">{message}</p>

        <div className="flex gap-3 justify-center">
          <button
            onClick={() => window.history.back()}
            className="px-4 py-2 text-sm border border-gray-200 rounded-lg hover:bg-gray-100 text-gray-700"
          >
            Go back
          </button>
          <Link
            to="/"
            className="px-4 py-2 text-sm bg-indigo-600 text-white rounded-lg hover:bg-indigo-700"
          >
            Home
          </Link>
        </div>
      </div>
    </div>
  );
}
